import { render, staticRenderFns } from "./VerguetungTable.vue?vue&type=template&id=4c44a741&"
import script from "./VerguetungTable.vue?vue&type=script&lang=js&"
export * from "./VerguetungTable.vue?vue&type=script&lang=js&"
import style0 from "./VerguetungTable.vue?vue&type=style&index=0&id=4c44a741&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports